import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CartLineRepository} from "./cart-line-repository.service";
import {CartQuantityNotifier} from "@app/core/cart/domain/cart-quantity-notifier";
import {switchMap} from "rxjs/operators";

/**
 * Use Case to check if a promotion has already been added to the cart.
 */
@Injectable({
    providedIn: "root",
})
export class IsPromotionAddedUseCase {
    constructor(
        private cartLineRepository: CartLineRepository,
        private cartQuantityNotifier: CartQuantityNotifier
    ) { }

    execute(promotionCode: string): Observable<boolean> {
        return this.cartQuantityNotifier.cartQuantity$.pipe(
            switchMap(() => this.cartLineRepository.isPromotionAdded(promotionCode)),
        );
    }
}
